import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scheduleGoogleAnalyticsLoad } from '../utils/loadGoogleAnalytics';
import { GA_MEASUREMENT_ID } from '../constants/branding';

/**
 * Envoie les pages vues SPA à Google Analytics (GA4).
 * Ignore /admin pour ne pas polluer les stats.
 */
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    scheduleGoogleAnalyticsLoad();
  }, []);

  useEffect(() => {
    if (typeof window.gtag !== 'function') {
      return;
    }

    if (location.pathname.startsWith('/admin')) {
      return;
    }

    const pagePath = `${location.pathname}${location.search}`;
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: pagePath,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}

export default AnalyticsTracker;
